import styled from 'styled-components';
import ActionsBar from '#/components/UnifiedRfqs/components/bottom-tabs/ActionsBar';

const ActionsBarEmpty = styled(ActionsBar)`
  height: 2px;
  border-bottom: 0;
`;

export default ActionsBarEmpty;
